import axios from '@/utils/axios'

// GET ALL
export const getEngineers = (params = {}) => {
  return axios.get('/engineers', { params })
}

// GET BY ID
export const getEngineerById = (id) => {
  return axios.get(`/engineers/${id}`)
}

// DROPDOWN
export const getEngineerDropdown = () => {
  return axios.get('/engineers/dropdown')
}

// CREATE
export const createEngineer = (data) => {
  return axios.post('/engineers', data)
}

// UPDATE 
export const updateEngineer = (id, data) => {
  return axios.put(`/engineers/${id}`, data)
}

// DELETE
export const deleteEngineer = (id) => {
  return axios.delete(`/engineers/${id}`)
}